import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CartItem } from "../models/cart_item.model";
import { Cart } from "../models/cart.model";
import { CartService } from "../services/cart.service";
import { TranslateService } from "@ngx-translate/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class CartObserver {

  cart: Cart;
  cartItemCounter = 0;
  cartVisible = false;
  cartFetched = false;
  cartObserver: BehaviorSubject<Cart>;
  cartVisibilityObserver: BehaviorSubject<boolean>;
  cartItemCounterObserver: BehaviorSubject<number>;

  constructor(
    private cartService: CartService
  ) {
    this.cartObserver = new BehaviorSubject<Cart>(new Cart())
    this.fetchCart()
    this.cartVisibilityObserver = new BehaviorSubject<boolean>(this.cartVisible)
    this.cartItemCounterObserver = new BehaviorSubject<number>(this.cartItemCounter)
  }


  fetchCart() {
    this.cartService.cart().subscribe(
      (cart) => {
        this.updateCartItemCount(cart)
      }
    )
  }

  toggleCart() {
    this.cartVisible = !this.cartVisible
    this.cartVisibilityObserver.next(this.cartVisible)
  }

  hideCart() {
    this.cartVisible = false
    this.cartVisibilityObserver.next(this.cartVisible)
  }

  showCart() {
    this.cartVisible = true
    this.cartVisibilityObserver.next(this.cartVisible)
  }

  updateCartItemCount(cart = this.cart) {
    this.cart = cart
    this.cartFetched = true
    this.cartObserver.next(this.cart)
    let totalAmount = 0
    cart.cartItems.forEach(
      (item) => totalAmount += item.amount || 0
    )
    this.cartItemCounter = totalAmount;
    this.cartItemCounterObserver.next(this.cartItemCounter)
  }

}
